<template>
    <div class="wrapper-form-block-socio-dados" :inert="pPreview">
        <p><strong>Quais os dados do sócio?</strong></p>
        <br/>
        <div class="columns is-multiline">
            <div class="column is-12" :class="{'allow-markup-error': markupErrorNome}">
                <TrfInput
                label="Nome"
                placeholder="Nome"
                margin="0"
                id="form-block-socio-nome"
                v-model="formData.nome"
                maxLength="50"
                ref="BlockSocioNome"
                v-e2e="'block-nome-socio'"
                :required="false"
                @update:model-value="setNome"
                ></TrfInput>
                <p class="error-message" v-if="markupErrorNome">
                    Campo obrigatório!
                </p>
            </div>
            <div class="column is-6">
                <TrfDocumentoInput
                label="CPF"
                :aceitaCPF="true"
                :aceitaCNPJ="false"
                placeholder="Número do CPF"
                margin="0"
                id="form-block-socio-cpf"
                v-model="formData.cpf"
                ref="BlockSocioCPF"
                v-e2e="'block-cpf-socio'"
                :required="required && dirtyState.cpf"
                @update:model-value="setCpf"
                ></TrfDocumentoInput>
            </div>
            <div class="column is-6" :class="{'allow-markup-error': markupErrorNascimento}">
                <TrfDateInput
                :isDiaMesEAno="true"
                class="mb-0"
                label="Data de nascimento"
                placeholder="DD/MM/AAAA"
                id="form-block-socio-data-nascimento"
                maxlength="10"
                v-model="formData.nascimento"
                ref="BlockSocioDataNascimento"
                v-e2e="'block-dataNascimento-socio'"
                :required="false"
                @update:model-value="setNascimento"
                ></TrfDateInput>
                <p class="error-message" v-if="markupErrorNascimento">
                    Campo obrigatório!
                </p>
            </div>
            <div class="column is-4" :class="{'allow-markup-error': markupErrorIdentidade}">
                <TrfInput
                label="Identidade"
                placeholder="Número do RG"
                margin="0"
                id="form-block-socio-rg"
                v-model="formData.identidade"
                maxLength="15"
                ref="BlockSocioRg"
                v-e2e="'block-socio-rg'"
                :required="false"
                @update:model-value="setIdentidade"
                ></TrfInput>
                <p class="error-message" v-if="markupErrorIdentidade">
                    Campo obrigatório!
                </p>
            </div>
            <div class="column is-4" :class="{'allow-markup-error': markupErrorOrgaoEmissorIdentidade}">
                <TrfInput
                label="Órgão expedidor"
                placeholder="Órgão expedidor (ex: SSPRS)"
                id="form-block-socio-orgao-emissor"
                class="mb-0"
                v-model="formData.orgaoEmissorIdentidade"
                maxLength="10"
                ref="BlockSocioOrgaoEmissor"
                v-e2e="'block-orgaoEmissorRg-socio'"
                :required="false"
                @update:model-value="setOrgaoEmissorIdentidade"
                ></TrfInput>
                <p class="error-message" v-if="markupErrorOrgaoEmissorIdentidade">
                    Campo obrigatório!
                </p>
            </div>
            <div class="column is-4" :class="{'allow-markup-error': markupErrorEmissaoIdentidade}">
                <TrfDateInput
                :isDiaMesEAno="true"
                label="Data de emissão"
                placeholder="DD/MM/AAAA"
                id="form-block-socio-emissao-identidade"
                maxlength="10"
                class="mb-0"
                v-model="formData.emissaoIdentidade"
                ref="BlockSocioEmissaoIdentidade"
                v-e2e="'block-dataEmissaoRg-socio'"
                :required="false"
                @update:model-value="setEmissaoIdentidade"
                ></TrfDateInput>
                <p class="error-message" v-if="markupErrorEmissaoIdentidade">
                    Campo obrigatório!
                </p>
            </div>
        </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoSocioDados',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfInput: defineAsyncComponent(() => import('../../Input/index.vue')),
        TrfDocumentoInput: defineAsyncComponent(() => import('../../Input/TrfDocumentoInput.vue')),
        TrfDateInput: defineAsyncComponent(() => import('../../Input/TrfDateInput.vue')),
    },
    props: {
        pNome: {
            type: String,
            default: ''
        },
        pCpf: {
            type: String,
            default: ''
        },
        pNascimento: {
            type: String,
            default: ''
        },
        pIdentidade: {
            type: String,
            default: ''
        },
        pOrgaoEmissorIdentidade: {
            type: String,
            default: ''
        },
        pEmissaoIdentidade: {
            type: String,
            default: ''
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsDirty: {
            type: Boolean,
            default: false
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: null
        },
        required: {
            type: Boolean,
            default: true
        }
    },
    data() {
      return {
        formData: {
            nome: this.pNome,
            cpf: this.pCpf,
            nascimento: this.pNascimento,
            identidade: this.pIdentidade,
            orgaoEmissorIdentidade: this.pOrgaoEmissorIdentidade,
            emissaoIdentidade: this.pEmissaoIdentidade,
        },
        dirtyState: {
            nome: this.pIsDirty,
            cpf: this.pIsDirty,
            nascimento: this.pIsDirty,
            identidade: this.pIsDirty,
            orgaoEmissorIdentidade: this.pIsDirty,
            emissaoIdentidade: this.pIsDirty
        },
      };
    },
    computed: {
        cpfInternalValidation() {
            return this.$refs.BlockSocioCPF.verificarSeInputEValido()
        },
        isDirty: {
            get() {
                return this.dirtyState.nome && this.dirtyState.cpf && this.dirtyState.nascimento && this.dirtyState.identidade && this.dirtyState.orgaoEmissorIdentidade && this.dirtyState.emissaoIdentidade;
            },
            set(valor) {
                for(let campo in this.dirtyState) {
                    this.dirtyState[campo] = valor
                }
            }
        },
        isNomeInvalido() {
            if (!this.required) return false;
            return this.dirtyState.nome && !this.formData.nome?.trim()
        },
        markupErrorNome() {
            return !this.pPreview && this.isNomeInvalido
        },
        isCpfInvalido() {
            if (!this.required) return false;
            return this.dirtyState.cpf && (!this.formData.cpf || !this.cpfInternalValidation)
        },
        markupErrorCpf() {
            return !this.pPreview && this.isCpfInvalido
        },
        isNascimentoInvalido() {
            if (!this.required) return false;
            return this.dirtyState.nascimento && !this.formData.nascimento
        },
        markupErrorNascimento() {
            return !this.pPreview && this.isNascimentoInvalido
        },
        isIdentidadeInvalido() {
            if (!this.required) return false;
            return this.dirtyState.identidade && !this.formData.identidade?.trim()
        },
        markupErrorIdentidade() {
            return !this.pPreview && this.isIdentidadeInvalido
        },
        isOrgaoEmissorIdentidadeInvalido() {
            if (!this.required) return false;
            return this.dirtyState.orgaoEmissorIdentidade && !this.formData.orgaoEmissorIdentidade?.trim()
        },
        markupErrorOrgaoEmissorIdentidade() {
            return !this.pPreview && this.isOrgaoEmissorIdentidadeInvalido
        },
        isEmissaoIdentidadeInvalido() {
            if (!this.required) return false;
            return this.dirtyState.emissaoIdentidade && !this.formData.emissaoIdentidade
        },
        markupErrorEmissaoIdentidade() {
            return !this.pPreview && this.isEmissaoIdentidadeInvalido
        },
        isInvalida() {
            return this.isNomeInvalido || this.isCpfInvalido || this.isNascimentoInvalido || this.isIdentidadeInvalido || this.isOrgaoEmissorIdentidadeInvalido || this.isEmissaoIdentidadeInvalido;
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
                if(this.required && this.$refs.BlockSocioCPF) {
                    this.$refs.BlockSocioCPF.verificarSeInputEstaVazio(false)
                }
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        },
        pSocioEmPreenchimento: {
          immediate: true,
            handler(novo) {
                if (!novo) return;
                this.formData.nome = novo.socio.nome;
                this.formData.cpf = novo.socio.cpf;
                this.formData.nascimento = novo.socio.nascimento;
                this.formData.identidade = novo.socio.identidade;
                this.formData.orgaoEmissorIdentidade = novo.socio.orgaoEmissorIdentidade;
                this.formData.emissaoIdentidade = novo.socio.emissaoIdentidade;
            },
            deep: true
        }
    },
    methods: {
        setNome(nome) {
            this.formData.nome = nome;
            this.emitFormData(this.formData);
            this.dirtyState.nome = true;
        },
        setCpf(cpf) {
            this.formData.cpf = cpf;
            this.emitFormData(this.formData);
            this.dirtyState.cpf = true;
        },
        setNascimento(nascimento) {
            this.formData.nascimento = nascimento;
            this.emitFormData(this.formData);
            this.dirtyState.nascimento = true;
        },
        setIdentidade(identidade) {
            this.formData.identidade = identidade;
            this.emitFormData(this.formData);
            this.dirtyState.identidade = true;
        },
        setOrgaoEmissorIdentidade(orgaoEmissorIdentidade) {
            this.formData.orgaoEmissorIdentidade = orgaoEmissorIdentidade;
            this.emitFormData(this.formData);
            this.dirtyState.orgaoEmissorIdentidade = true;
        },
        setEmissaoIdentidade(emissaoIdentidade) {
            this.formData.emissaoIdentidade = emissaoIdentidade;
            this.emitFormData(this.formData);
            this.dirtyState.emissaoIdentidade = true;
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', formData)
        }
    }
  };
  </script>
  